var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { Typography, Button, Box, Table, TableHead, TableBody, TableRow, TableCell, Collapse, Checkbox } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CustomSwitch from '../../components/uiComponents/CustomSwitch';
import { EditPencilIcon } from '../../components/icons';
var PermissionsBox = function (_a) {
    var open = _a.open, onClose = _a.onClose, roleName = _a.roleName, roleType = _a.roleType, permissions = _a.permissions, onSave = _a.onSave, _b = _a.canUpdate, canUpdate = _b === void 0 ? true : _b;
    var _c = useState(false), editMode = _c[0], setEditMode = _c[1];
    var _d = useState([]), editPerms = _d[0], setEditPerms = _d[1];
    var _e = useState({}), expandedSections = _e[0], setExpandedSections = _e[1];
    var _f = useState(false), hasChanges = _f[0], setHasChanges = _f[1];
    var permissionKeys = ['View', 'Add', 'Update', 'Delete'];
    useEffect(function () {
        var safePermissions = permissions || [];
        setEditPerms(JSON.parse(JSON.stringify(safePermissions)));
        setHasChanges(false);
        setEditMode(false);
        setExpandedSections({});
    }, [permissions, open]);
    var handleSave = function () {
        setEditMode(false);
        setHasChanges(false);
        if (onSave)
            onSave(editPerms);
    };
    var handleCancel = function () {
        setEditMode(false);
        setEditPerms(JSON.parse(JSON.stringify(permissions)));
        setHasChanges(false);
    };
    var isChecked = function (value) {
        return value === 1;
    };
    var isPermissionDisabled = function (value) {
        return value === 2;
    };
    var handleToggle = function (path, key) {
        setHasChanges(true);
        setEditPerms(function (perms) {
            var _a;
            var newPerms = JSON.parse(JSON.stringify(perms));
            var current = newPerms;
            for (var i = 0; i < path.length - 1; i++) {
                current = current[path[i]].SubModules;
            }
            var target = current[path[path.length - 1]];
            var currentValue = target[key];
            if (isPermissionDisabled(currentValue))
                return newPerms;
            var newValue = isChecked(currentValue) ? 0 : 1;
            target[key] = newValue;
            if (key === 'View' && newValue === 0) {
                ['Add', 'Update', 'Delete'].forEach(function (k) {
                    if (!isPermissionDisabled(target[k])) {
                        target[k] = 0;
                    }
                });
            }
            var enableKeyRecursive = function (modules) {
                modules.forEach(function (mod) {
                    var _a;
                    if (key !== 'View' && mod.View !== 1) {
                        return;
                    }
                    if (!isPermissionDisabled(mod[key])) {
                        mod[key] = 1;
                    }
                    if ((_a = mod.SubModules) === null || _a === void 0 ? void 0 : _a.length) {
                        enableKeyRecursive(mod.SubModules);
                    }
                });
            };
            var disableKeyRecursive = function (modules) {
                modules.forEach(function (mod) {
                    var _a;
                    if (!isPermissionDisabled(mod[key])) {
                        mod[key] = 0;
                    }
                    if (key === 'View') {
                        ['Add', 'Update', 'Delete'].forEach(function (k) {
                            if (!isPermissionDisabled(mod[k])) {
                                mod[k] = 0;
                            }
                        });
                    }
                    if ((_a = mod.SubModules) === null || _a === void 0 ? void 0 : _a.length) {
                        disableKeyRecursive(mod.SubModules);
                    }
                });
            };
            if ((_a = target.SubModules) === null || _a === void 0 ? void 0 : _a.length) {
                if (newValue === 1) {
                    enableKeyRecursive(target.SubModules);
                }
                else {
                    disableKeyRecursive(target.SubModules);
                }
            }
            if (newValue === 0 && path.length >= 2) {
                var _loop_1 = function (level) {
                    var parentPath = path.slice(0, level);
                    var parentCurrent = newPerms;
                    for (var i = 0; i < parentPath.length - 1; i++) {
                        parentCurrent = parentCurrent[parentPath[i]].SubModules;
                    }
                    var parent_1 = parentCurrent[parentPath[parentPath.length - 1]];
                    var siblings = parent_1.SubModules || [];
                    var anyChecked = siblings.some(function (s) { return s[key] === 1; });
                    if (!anyChecked && !isPermissionDisabled(parent_1[key])) {
                        parent_1[key] = 0;
                        if (key === 'View') {
                            ['Add', 'Update', 'Delete'].forEach(function (k) {
                                if (!isPermissionDisabled(parent_1[k]))
                                    parent_1[k] = 0;
                            });
                        }
                    }
                    else {
                        return "break";
                    }
                };
                for (var level = path.length - 1; level >= 1; level--) {
                    var state_1 = _loop_1(level);
                    if (state_1 === "break")
                        break;
                }
            }
            return newPerms;
        });
    };
    var toggleSection = function (sectionKey) {
        setExpandedSections(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[sectionKey] = !prev[sectionKey], _a)));
        });
    };
    var hasParentPermission = function (parentPath, key) {
        if (parentPath.length === 0)
            return true;
        var current = editPerms;
        for (var i = 0; i < parentPath.length - 1; i++) {
            current = current[parentPath[i]].SubModules;
        }
        var parent = current[parentPath[parentPath.length - 1]];
        return parent[key] === 1;
    };
    var enableAllRecursive = function (module) {
        var enabled = __assign({}, module);
        permissionKeys.forEach(function (key) {
            var value = enabled[key];
            if (!isPermissionDisabled(value)) {
                enabled[key] = 1;
            }
        });
        if (enabled.SubModules) {
            enabled.SubModules = enabled.SubModules.map(function (sub) { return enableAllRecursive(sub); });
        }
        return enabled;
    };
    var disableAllRecursive = function (module) {
        var disabled = __assign({}, module);
        permissionKeys.forEach(function (key) {
            var value = disabled[key];
            if (!isPermissionDisabled(value)) {
                disabled[key] = 0;
            }
        });
        if (disabled.SubModules) {
            disabled.SubModules = disabled.SubModules.map(function (sub) { return disableAllRecursive(sub); });
        }
        return disabled;
    };
    var handleEnableAll = function (path) {
        setHasChanges(true);
        setEditPerms(function (perms) {
            var newPerms = JSON.parse(JSON.stringify(perms));
            var current = newPerms;
            for (var i = 0; i < path.length - 1; i++) {
                current = current[path[i]].SubModules;
            }
            current[path[path.length - 1]] = enableAllRecursive(current[path[path.length - 1]]);
            return newPerms;
        });
    };
    var handleDisableAll = function (path) {
        setHasChanges(true);
        setEditPerms(function (perms) {
            var newPerms = JSON.parse(JSON.stringify(perms));
            var current = newPerms;
            for (var i = 0; i < path.length - 1; i++) {
                current = current[path[i]].SubModules;
            }
            current[path[path.length - 1]] = disableAllRecursive(current[path[path.length - 1]]);
            return newPerms;
        });
    };
    var renderSubModules = function (subModules, parentPath, depth) {
        if (depth === void 0) { depth = 1; }
        return (React.createElement(React.Fragment, null, subModules.map(function (subModule, subIdx) {
            var currentPath = __spreadArray(__spreadArray([], parentPath, true), [subIdx], false);
            var sectionKey = subModule.PermissionKey;
            var hasNestedSubModules = subModule.SubModules && subModule.SubModules.length > 0;
            return (React.createElement(React.Fragment, { key: subModule.PermissionKey },
                React.createElement(TableRow, { sx: { backgroundColor: depth % 2 === 0 ? "#fafafa" : "#ffffff" } },
                    React.createElement(TableCell, { sx: { pl: 2 + (depth * 2), py: 1.5, minWidth: 300, border: "none" } },
                        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                            React.createElement(Typography, { variant: "body2", color: "text.secondary", fontSize: 13 }, subModule.SubModuleName),
                            hasNestedSubModules && (React.createElement(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    cursor: 'pointer',
                                }, onClick: function () { return toggleSection(sectionKey); } },
                                React.createElement(Typography, { variant: "caption", color: "primary", fontSize: "11px" },
                                    subModule.SubModules.length,
                                    " sub section"),
                                expandedSections[sectionKey] ? (React.createElement(ExpandLessIcon, { sx: { fontSize: 16 }, color: "primary" })) : (React.createElement(ExpandMoreIcon, { sx: { fontSize: 16 }, color: "primary" })))))),
                    permissionKeys.map(function (key) {
                        var value = subModule[key];
                        var parentHasPermission = hasParentPermission(parentPath, key);
                        return (React.createElement(TableCell, { key: key, align: "center", sx: { width: 100, py: 0.5, border: "none" } },
                            React.createElement(Checkbox, { checked: isChecked(value), onChange: function () { return handleToggle(currentPath, key); }, disabled: !editMode || isPermissionDisabled(value) ||
                                    !parentHasPermission ||
                                    (key !== 'View' && !isChecked(subModule['View'])), size: "small", sx: {
                                    '&.Mui-disabled': {
                                        color: 'rgba(0, 0, 0, 0.26)',
                                    }
                                } })));
                    })),
                hasNestedSubModules && (React.createElement(TableRow, null,
                    React.createElement(TableCell, { colSpan: 5, sx: { p: 0, border: "none" } },
                        React.createElement(Collapse, { in: expandedSections[sectionKey], timeout: "auto", unmountOnExit: true },
                            React.createElement(Box, null,
                                React.createElement(Table, { size: "small" },
                                    React.createElement(TableBody, null, renderSubModules(subModule.SubModules, currentPath, depth + 1))))))))));
        })));
    };
    if (!open)
        return null;
    return (React.createElement(Box, { sx: {
            width: '100%',
            borderLeft: '1px solid #e0e0e0',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: '#ffffff',
            height: '100%',
            overflow: 'hidden'
        } },
        React.createElement(Box, { sx: {
                px: 2,
                py: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #e0e0e0',
                bgcolor: '#fafafa'
            } },
            React.createElement(Box, null,
                React.createElement(Typography, { fontSize: 16, fontWeight: 600 },
                    roleName,
                    " Permissions")),
            canUpdate && (React.createElement(Box, { sx: {
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                } }, editMode ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { variant: "outlined", color: "inherit", sx: { textTransform: 'none', fontSize: '13px' }, onClick: handleCancel, size: 'small' }, "Cancel"),
                React.createElement(Button, { variant: "contained", color: "primary", size: 'small', sx: { textTransform: 'none', fontSize: '13px' }, onClick: handleSave, disabled: !hasChanges }, "Save Changes"))) : (editPerms.length > 0 && (React.createElement(Button, { variant: "contained", color: "primary", sx: { textTransform: 'none', fontSize: '13px' }, onClick: function () {
                    setEditMode(true);
                }, size: 'small', startIcon: React.createElement(EditPencilIcon, { fill: "#fff" }) }, "Edit Permissions")))))),
        React.createElement(Box, { sx: { flex: 1, overflowY: 'auto' } }, editPerms.length === 0 ? (React.createElement(Box, { sx: { p: 4, textAlign: 'center' } },
            React.createElement(Typography, { color: "text.secondary" }, "No permissions available for this role"))) : (React.createElement(Table, { stickyHeader: true, size: "small" },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { sx: {
                            fontWeight: 600,
                            bgcolor: '#f7f7f7',
                            color: "#1F275C",
                            minWidth: 300,
                            px: 2,
                            py: 1.5,
                            fontSize: '14px'
                        } }, "Module / Feature"),
                    React.createElement(TableCell, { align: "center", sx: {
                            fontWeight: 600,
                            bgcolor: '#f7f7f7',
                            color: "#1F275C",
                            width: 100,
                            px: 2,
                            py: 1.5,
                            fontSize: '14px'
                        } }, "View"),
                    React.createElement(TableCell, { align: "center", sx: {
                            fontWeight: 600,
                            bgcolor: '#f7f7f7',
                            color: "#1F275C",
                            width: 100,
                            px: 2,
                            py: 1.5,
                            fontSize: '14px'
                        } }, "Create"),
                    React.createElement(TableCell, { align: "center", sx: {
                            fontWeight: 600,
                            bgcolor: '#f7f7f7',
                            color: "#1F275C",
                            width: 100,
                            px: 2,
                            py: 1.5,
                            fontSize: '14px'
                        } }, "Edit"),
                    React.createElement(TableCell, { align: "center", sx: {
                            fontWeight: 600,
                            bgcolor: '#f7f7f7',
                            color: "#1F275C",
                            width: 100,
                            px: 2,
                            py: 1.5,
                            fontSize: '14px'
                        } }, "Delete"))),
            React.createElement(TableBody, null, editPerms.map(function (perm, idx) { return (React.createElement(React.Fragment, { key: perm.PermissionKey },
                React.createElement(TableRow, { sx: {
                        '&:hover': { bgcolor: editMode ? 'rgba(0, 0, 0, 0.02)' : 'transparent' },
                        bgcolor: '#fff'
                    } },
                    React.createElement(TableCell, { sx: { px: 2, py: 1.5 } },
                        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                            React.createElement(Typography, { variant: "body2", fontWeight: 400, fontSize: 14 }, perm.PermissionName),
                            perm.SubModules && perm.SubModules.length > 0 && (React.createElement(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    cursor: 'pointer',
                                }, onClick: function () { return toggleSection(perm.PermissionKey); } },
                                React.createElement(Typography, { variant: "caption", color: "primary", fontSize: 11 },
                                    perm.SubModules.length,
                                    " sub section"),
                                expandedSections[perm.PermissionKey] ? (React.createElement(ExpandLessIcon, { fontSize: "small", color: "primary" })) : (React.createElement(ExpandMoreIcon, { fontSize: "small", color: "primary" })))),
                            editMode && perm.SubModules && perm.SubModules.length > 0 && (React.createElement(Box, { sx: { display: 'flex', gap: 1 } },
                                React.createElement(Button, { size: "small", onClick: function () { return handleEnableAll([idx]); }, sx: {
                                        textTransform: 'none',
                                        fontSize: '11px',
                                        color: '#2e7d32',
                                        p: 0,
                                        minWidth: 'auto'
                                    } }, "Enable All"),
                                React.createElement(Button, { size: "small", onClick: function () { return handleDisableAll([idx]); }, sx: {
                                        textTransform: 'none',
                                        fontSize: '11px',
                                        color: '#d32f2f',
                                        p: 0,
                                        minWidth: 'auto'
                                    } }, "Disable All"))))),
                    permissionKeys.map(function (key) {
                        var value = perm[key];
                        return (React.createElement(TableCell, { key: key, align: "center", sx: { px: 2, py: 1.5 } },
                            React.createElement(CustomSwitch, { checked: isChecked(value), onChange: function () { return editMode && handleToggle([idx], key); }, disabled: !editMode || isPermissionDisabled(value) ||
                                    (key !== 'View' && !isChecked(perm['View'])), size: "small", sx: {
                                    pointerEvents: editMode ? 'auto' : 'none',
                                    cursor: editMode ? 'pointer' : 'not-allowed'
                                } })));
                    })),
                perm.SubModules && perm.SubModules.length > 0 && (React.createElement(TableRow, null,
                    React.createElement(TableCell, { colSpan: 5, sx: { p: 0, border: "none" } },
                        React.createElement(Collapse, { in: expandedSections[perm.PermissionKey], timeout: "auto", unmountOnExit: true },
                            React.createElement(Box, null,
                                React.createElement(Table, { size: "small" },
                                    React.createElement(TableBody, null, renderSubModules(perm.SubModules, [idx])))))))))); })))))));
};
export default PermissionsBox;
